<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-title>{{ 'general.search' | translate }}</ion-title>
    <ion-buttons slot="start">
      <ion-button
        (click)="cancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-grid class="ion-padding-vertical-0 ion-margin-top-0 block-content-round">
    <ion-row>
      <ion-col>
        <form [formGroup]="searchForm">
          <ion-item lines="none">
            <ion-toggle
              justify="start"
              labelPlacement="end"
              [checked]="withoutPlate()"
              (ionChange)="onWithoutPlateChange($event.detail.checked)"
            >
              {{ 'deca.search.without_plate' | translate }}
            </ion-toggle>
          </ion-item>

          @if (!withoutPlate()) {
            <div class="ion-padding-vertical">
              <ion-input
                formControlName="plate"
                label="{{ 'deca.search.plate' | translate }}"
                labelPlacement="floating"
                fill="outline"
                mode="md"
                inputmode="text"
                [clearInput]="true"
                placeholder="{{ 'deca.search.plate' | translate }}"
              ></ion-input>
            </div>
          }
        </form>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-grid class="ion-padding-vertical-0">
      <ion-row>
        <ion-col>
          <ion-button
            (click)="confirm()"
            color="primary"
            expand="block"
            fill="solid"
          >
            <ion-icon
              src="../assets/material-symbols/search_24dp.svg"
              slot="start"
            ></ion-icon>
            {{ 'general.search' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
